<template>
  <el-tooltip
    v-if="hasTextSlot"
    :placement="placement"
    :effect="effect"
    :trigger="trigger"
    :disabled="disabled"
    :popper-class="`sj-tooltip ${popperClass}`"
    :offset="8"
    :show-after="showAfter"
    :hide-after="hideAfter"
    :transition="transition"
    :teleported="teleported"
    class="shadow-lg"
  >
    <template #content>
      <div class=""><slot name="text" /></div>
    </template>

    <slot />
  </el-tooltip>

  <!-- Если нет text слота, показываем только default слот без тултипа -->
  <slot v-else />
</template>

<script setup lang="ts">
  // @ts-ignore
  import type { Placement } from "@popperjs/core";
  import { useSlots } from "vue";

  interface Props {
    placement?: Placement | "auto";
    effect?: "light" | "dark";
    trigger?: "hover" | "click" | "focus" | "contextmenu";
    disabled?: boolean;
    popperClass?: string;
    showAfter?: number;
    hideAfter?: number;
    transition?: string;
    teleported?: boolean;
  }
  withDefaults(defineProps<Props>(), {
    placement: "auto",
    effect: "light",
    trigger: "hover",
    disabled: false,
    popperClass: "",
    showAfter: 100,
    hideAfter: 0,
    transition: "el-fade-in-linear",
    teleported: true,
  });

  const slots = useSlots();
  const hasTextSlot = !!slots.text;
</script>

<style>
  .sj-tooltip {
    box-shadow:
      0 4px 6px -1px rgb(0 0 0 / 0.1),
      0 2px 4px -2px rgb(0 0 0 / 0.1);
  }
</style>
